import { EnglishService } from "../languages/english.service";
import { GermanService } from "../languages/german.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Subject } from "rxjs/Subject";
import { ItalianService } from "../languages/italian.service";
import { SpanishService } from "../languages/spanish.service";
import { FrenchService } from "../languages/french.service";
import { Injectable } from "@angular/core";
import { BaseLanguage } from "app/languages/baseLang.service";
import { format } from "util";

// #########################################################################
//
// This service is used to keep track of all information about the language
// so we keep track of the following thing and provide an interface to access
// those information from a component:
//      - language
//      - language abbreviation
//
// There are specific Language Services (EnglishService and GermanService)
// Which keep the information to be filled into the hashtables when we set the
// system language. In general we use hasmaps with the same keys, and so we can
// exchange the actual hashmap dynamically
//
// #########################################################################

@Injectable()
export class LanguageService {
  public static EnglishID = "en";
  public static GermanID = "de";
  public static ItalianID = "it";
  public static FrenchID = "fr";
  public static SpanishID = "es";

  private lang: Map<string, string>;
  private languageAbbreviation;

  // This line used to be like this. But as the type of lang has changed and it is initialized in the constructor instead of
  // here directly, the new line has the same effect.
  public space: Subject<string> = new BehaviorSubject<string>(undefined);

  constructor() {
    // depending on system language load different language service
    let systemLanguage = navigator.language.slice(0, 2);
    this.setLang(systemLanguage);
  }

  public setLang(abbrev: string): void {
    let languageService: BaseLanguage;
    switch (abbrev) {
      case LanguageService.EnglishID:
        languageService = new EnglishService();
        this.languageAbbreviation = LanguageService.EnglishID;
        break;
      case LanguageService.GermanID:
        languageService = new GermanService();
        this.languageAbbreviation = LanguageService.GermanID;
        break;
      case LanguageService.ItalianID:
        languageService = new ItalianService();
        this.languageAbbreviation = LanguageService.ItalianID;
        break;
      case LanguageService.FrenchID:
        languageService = new FrenchService();
        this.languageAbbreviation = LanguageService.FrenchID;
        break;
      case LanguageService.SpanishID:
        languageService = new SpanishService();
        this.languageAbbreviation = LanguageService.SpanishID;
        break;
      default:
        languageService = new EnglishService();
        this.languageAbbreviation = LanguageService.EnglishID;
    }
    this.lang = languageService.getLang();
  }

  public translateKey(
    word: string,
    templateArg?: { [key: string]: string }
  ): string {
    if (!this.lang) {
      throw Error(
        "No language has been initialized. Translation not possible."
      );
    }
    let translated: string = this.lang[word];
    if (!translated) {
      console.error("No translation for key '" + word + "'");
      return word;
    }

    if (templateArg) {
      for (const key in templateArg) {
        // Replace all templates in the form of {keyname} in the string. This allows the translation
        // to be parametrized based on values, like the error of a syntax checking
        // TODO: Allow whitespace before and after key between the curly braces.
        translated = translated.replace(`{${key}}`, templateArg[key]);
      }
    }

    return translated;
  }

  public getLang(): Map<string, string> {
    return this.lang;
  }

  public getLangAbbrev(): string {
    return this.languageAbbreviation;
  }

  public setHeaderText(text: string) {
    this.lang["XLogoOnline"] = text;
  }

  public setHeadLineTextTo(text: string, className: string): void {
    //set new text value and color
    if (document.getElementById("headerText") != null) {
      document.getElementById("headerText").className = className;
      document.getElementById("headerText").textContent = text;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/language.service.ts